/** determines whether a user have access to new SC apis */
/**commented new sc code temporarily */
// const isNewSCApiUser = () => localStorage.getItem("isNewSCApiUser");
const isNewSCApiUser = () => {
  return false;
};
export default isNewSCApiUser;
